import React from 'react';
import { Dialog, DialogContent, Grid, Hidden, IconButton, Typography, Button, Box, Link } from '@material-ui/core';
import { Close } from '@material-ui/icons';
import CheckIcon from './CheckIcon';
import clsx from 'clsx';
import useclasses from './WallModal.style';
import cx from 'clsx';
export var TypeEnum;
(function (TypeEnum) {
    TypeEnum[TypeEnum["try_free"] = 0] = "try_free";
    TypeEnum[TypeEnum["try_pro"] = 1] = "try_pro";
    TypeEnum[TypeEnum["login"] = 2] = "login";
})(TypeEnum || (TypeEnum = {}));
const DEFAULT_CTA = {
    [TypeEnum.try_free]: { text: 'Try for FREE', iconUrl: null },
    [TypeEnum.try_pro]: {
        text: 'Upgrade to Pro',
        iconUrl: 'https://assets.designs.ai/images/procrown.svg'
    },
    [TypeEnum.login]: {
        text: 'Log in',
        iconUrl: null
    }
};
const DEFAULT_BANNER_IMG_URL = 'https://assets.designs.ai/images/update_modal_banner.png';
const DEFAULT_TEXT_EN = {
    header: 'Subscribe and Enjoy Full Features!',
    description: 'Get greater savings and access the full Designs.ai suite of tools!',
    title: 'Here’s briefly what you will get :',
    list: [
        {
            iconUrl: 'https://assets.designs.ai/icons/dsai.svg',
            text: (React.createElement("span", null,
                "Full access to ",
                React.createElement("b", null, "Logomaker, Videomaker, Designmaker, Speechmaker")))
        },
        {
            iconUrl: 'https://assets.designs.ai/icons/unlimited.svg',
            text: (React.createElement("span", null,
                "Create ",
                React.createElement("b", null, "unlimited projects"),
                " within all tools"))
        },
        {
            iconUrl: 'https://assets.designs.ai/icons/add-image.svg',
            text: (React.createElement("span", null,
                React.createElement("b", null, "Unlimited usage"),
                " of 15 million high-quality video clip, audio and image assets"))
        },
        {
            iconUrl: 'https://assets.designs.ai/icons/Vector.svg',
            text: (React.createElement("span", null,
                "Monthly ",
                React.createElement("b", null, "premium images and video clips"),
                " to elevate your ideas"))
        },
        {
            iconUrl: 'https://assets.designs.ai/icons/team.svg',
            text: (React.createElement("span", null,
                React.createElement("b", null, "Team collaboration"),
                " via multiseat access"))
        }
    ]
};
const DEFAULT_SPEECHMAKER_LOGIN_CONTENT_EN = {
    Free: [
        {
            iconUrl: null,
            text: React.createElement("span", null, "500 characters per query")
        },
        {
            iconUrl: null,
            text: React.createElement("span", null, "Daily quota applied")
        },
        {
            iconUrl: null,
            text: React.createElement("span", null, "Personal usage")
        }
    ],
    Basic: [
        {
            iconUrl: null,
            text: React.createElement("span", null, "3000 characters per query")
        },
        {
            iconUrl: null,
            text: React.createElement("span", null, "Monthly quota applied")
        },
        {
            iconUrl: null,
            text: React.createElement("span", null, "Personal usage")
        }
    ],
    Pro: [
        {
            iconUrl: null,
            text: React.createElement("span", null, "3000 characters per query")
        },
        {
            iconUrl: null,
            text: React.createElement("span", null, "Unlimited quota")
        },
        {
            iconUrl: null,
            text: React.createElement("span", null, "Commercial usage")
        }
    ]
};
export const WallModal = ({ onClose, ctaOnClick, list, show, header, description, title, ctaText, ctaIconUrl, type, ctaHref, bannerImgUrl, customListComponent, loginTypeList, subLink, subLinkText, subLinkStyle, alignment, overidePosition, dataLoading, buttonColor, buttonTextColor, hoverButtonColor, hoverButtonTextColor }) => {
    var _a;
    const classes = useclasses();
    const handleClose = () => {
        if (!dataLoading) {
            onClose();
        }
    };
    return (React.createElement(Dialog, { onClose: handleClose, maxWidth: 'lg', fullWidth: true, open: show, classes: { scrollPaper: classes.scrollPaper, root: classes.root } },
        React.createElement(DialogContent, { className: classes.dialogContent },
            React.createElement("div", { className: classes.closeBtnWrapper },
                React.createElement(IconButton, { onClick: handleClose, className: classes.closeBtn },
                    React.createElement(Close, null))),
            React.createElement(Grid, { container: true },
                React.createElement(Grid, { className: classes.leftCol, lg: 6, md: 7, sm: 12, item: true },
                    React.createElement(Typography, { className: cx(classes.textHeader, alignment) }, header || DEFAULT_TEXT_EN.header),
                    React.createElement(Typography, { className: cx(classes.textDescription, alignment) }, description || DEFAULT_TEXT_EN.description),
                    type !== TypeEnum.login && (React.createElement(Typography, { className: classes.textTitle }, title || DEFAULT_TEXT_EN.title)),
                    customListComponent
                        ? customListComponent
                        : type !== TypeEnum.login
                            ? (list || DEFAULT_TEXT_EN.list).map(({ text, iconUrl }, key) => (React.createElement("div", { className: clsx(classes.itemListWrapper, classes.divMb), key: key },
                                React.createElement("img", { className: classes.listIcon, alt: iconUrl, src: iconUrl }),
                                React.createElement(Typography, { className: classes.listText }, text))))
                            : Object.entries(loginTypeList || DEFAULT_SPEECHMAKER_LOGIN_CONTENT_EN).map(([categoryTitle, categoryList]) => {
                                return (React.createElement(Box, { key: categoryTitle, className: classes.divMb },
                                    React.createElement(Typography, { className: classes.textTitle },
                                        categoryTitle,
                                        " :"),
                                    categoryList.map(({ text, iconUrl }, key) => (React.createElement("div", { className: classes.itemListWrapper, key: key },
                                        iconUrl ? (React.createElement("img", { className: classes.listIcon, alt: `icon-${key}`, src: iconUrl })) : (React.createElement(CheckIcon, { className: classes.checkIcon })),
                                        React.createElement(Typography, { className: classes.listText }, text))))));
                            }),
                    React.createElement(Button, { startIcon: (ctaIconUrl || ((_a = DEFAULT_CTA[type]) === null || _a === void 0 ? void 0 : _a.iconUrl)) && (React.createElement("img", { className: classes.ctaIcon, alt: 'cta-button-icon', src: ctaIconUrl || DEFAULT_CTA[type].iconUrl })), fullWidth: true, href: ctaHref, color: 'primary', variant: 'contained', onClick: ctaOnClick, disabled: dataLoading, sx: {
                            background: `${buttonColor || ''} !important`,
                            color: `${buttonTextColor || ''} !important`,
                            ':hover': {
                                background: `${hoverButtonColor || ''} !important`,
                                color: `${hoverButtonTextColor || ''} !important`
                            }
                        }, className: `${classes.ctaButton}` }, ctaText ||
                        (type && DEFAULT_CTA[type].text) ||
                        DEFAULT_CTA[TypeEnum.try_free].text),
                    subLink && (React.createElement(Link, { component: 'a', href: subLink, underline: 'always', className: subLinkStyle }, subLinkText))),
                React.createElement(Hidden, { mdDown: true },
                    React.createElement(Grid, { lg: 6, md: 5, item: true },
                        React.createElement(Box, { sx: {
                                backgroundImage: `url(${bannerImgUrl || DEFAULT_BANNER_IMG_URL})`
                            }, className: cx(classes.img, overidePosition) })))))));
};
//# sourceMappingURL=index.js.map